import React from 'react';

const PrivacyPolicy = () => {
    return (

        <div className="bg-white py-20">
            <h2 className="my-20 mx-40 text-2xl font-bold text-gray-900 md:text-4xl">
                Privacy Policy
            </h2>

            <p className="mx-40 font-medium text-xl text-gray-600">
                **SMS Opt-In Clause:**
                <br />
                By providing your mobile number and clicking "Submit" or "Send," you consent to receive informational
                and promotional text messages from Jobs For Us at the phone number provided. Message frequency may vary.
                Message and data rates may apply. Reply "STOP" to unsubscribe or "HELP" for assistance. Your consent is not a condition of purchase.
                <br />
                **Privacy Policy for SMS:** At Jobs For Us, we value your privacy and are committed to protecting your
                personal information. Our SMS program is designed to provide you with relevant updates and information
                about job opportunities, career advice, and our services. Here's how we handle your data:
                <br />
                1. **Information Collection:** We collect your mobile phone number when you opt in to receive SMS
                messages from us. We do not collect any additional personal information through our SMS program.
                <br />
                2. **Message Frequency:** You may receive periodic text messages from us, including job alerts, career tips,
                and promotional offers. Message frequency may vary but will not exceed the limits set by applicable laws and
                regulations.
                <br />
                3. **Message and Data Rates:** Message and data rates may apply depending on your mobile carrier plan.
                These rates are solely your responsibility. We recommend checking with your carrier for details.
                <br />
                4. **Unsubscribe:** You can opt-out of our SMS program at any time by replying with "STOP" to any message
                you receive from us. You will no longer receive SMS messages from us after unsubscribing.
                <br />
                5. **Help and Support:** If you have any questions or need assistance regarding our SMS program, you can reply
                with "HELP," and we will provide you with the necessary support.
                <br />
                6. **Privacy:** Your mobile number and any other personal information provided are kept confidential and will
                not be shared, sold, or disclosed to third parties, except as required by law.
                <br />
                7. **Security:** We take reasonable measures to protect your information; however, please be aware that SMS
                messages are not entirely secure. Use caution when sharing sensitive information via SMS.
                <br />
                8. **Changes to the Privacy Policy:** We may update this privacy policy to reflect changes in our SMS program
                or legal requirements.Any updates will be posted on our website. By participating in our SMS program, you
                agree to the terms outlined in this privacy policy. Please note that this is a general template, and you may
                need to review it with legal counsel to ensure it complies with all relevant regulations and laws in your
                jurisdiction.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
